import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import { makeMe } from '../../main/usecases/me/load-me-factory'
import HelperAmplify from '../helpers/helper-amplify'
import IMe from '../interfaces/me'

type IProps = {
  children: ReactNode
}

type MeContextProps = {
  updateMe: (value: IMe) => void
  me: IMe | null
}

const MeContext = createContext<MeContextProps>({
  me: null,
  updateMe: () => null,
})

const MeProvider: React.FC<IProps> = ({ children }) => {
  const [me, setMe] = useState<null | IMe>(null)

  const updateMe = (value: IMe) => {
    setMe(value)
  }

  useEffect(() => {
    async function loadContext() {
      try {
        if (!(await HelperAmplify.isAuth())) {
          return
        }
        const response = await makeMe().load()
        updateMe(response)
      } catch (err: any) {
        if (err.message === 'No current user') {
          return
        }
        await HelperAmplify.signOut()
      }
    }

    loadContext()
  }, [])

  return (
    <MeContext.Provider
      value={{
        me,
        updateMe,
      }}
    >
      {children}
    </MeContext.Provider>
  )
}

export const useMe = () => {
  const context = useContext(MeContext)

  if (!context) {
    throw new Error('useMe must be used within a provider MeProvider')
  }

  return context
}

export default MeProvider
